import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "user-interface"
    }}>{`User Interface`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sp-action-button.md"
        }}>{`sp-action-button`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sp-button.md"
        }}>{`sp-button`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sp-checkbox.md"
        }}>{`sp-checkbox`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sp-divider.md"
        }}>{`sp-divider`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sp-dropdown.md"
        }}>{`sp-dropdown`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sp-icon.md"
        }}>{`sp-icon`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sp-link.md"
        }}>{`sp-link`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sp-menu-item.md"
        }}>{`sp-menu-item`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sp-menu.md"
        }}>{`sp-menu`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sp-progressbar.md"
        }}>{`sp-progressbar`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sp-radio-group.md"
        }}>{`sp-radio-group`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sp-radio.md"
        }}>{`sp-radio`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sp-slider.md"
        }}>{`sp-slider`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sp-textarea.md"
        }}>{`sp-textarea`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sp-textfield.md"
        }}>{`sp-textfield`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      